import React from 'react';

export default function Arrow({
  direction = 'right',
  width = 51,
  height = 51
}) {
  const degrees = direction === 'right'
    ? 0 : 180;

  return (
    <svg
      width={width || 51} height={height || 51} viewBox="0 0 51 51"
      fill="none" xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${degrees}deg)`}}
    >
        <path d="M14.154 25.003h22.588" stroke="#202020" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="m29.723 32.023 7.02-7.02-7.02-7.019" stroke="#202020" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}